module.exports = __webpack_public_path__ + "img/authorized_signature.9014839f.svg";